var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 19,
    viewBox: "0 0 26 19",
    fill: "#026F30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49997 15.255L3.29497 10.05C3.01451 9.76953 2.63411 9.61196 2.23747 9.61196C1.84083 9.61196 1.46044 9.76953 1.17997 10.05C0.899508 10.3305 0.741943 10.7109 0.741943 11.1075C0.741943 11.3039 0.780627 11.4984 0.855784 11.6798C0.930942 11.8613 1.0411 12.0261 1.17997 12.165L7.44998 18.435C8.03498 19.02 8.97997 19.02 9.56497 18.435L25.435 2.56499C25.7154 2.28453 25.873 1.90413 25.873 1.50749C25.873 1.11085 25.7154 0.730461 25.435 0.449994C25.1545 0.169528 24.7741 0.0119629 24.3775 0.0119629C23.9808 0.0119629 23.6004 0.169528 23.32 0.449994L8.49997 15.255Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedIcon);
export default __webpack_public_path__ + "static/media/checked-icon.77970602fdff412187a1fb729274f700.svg";
export { ForwardRef as ReactComponent };